import * as React from 'react'
import { tryCatch } from '../../utils/tryCatch'
import { withFatalCheck } from '../error/withFatalCheck'
import { ICollection } from '../../selectors/collections'
import { Spacing, Carousel } from 'DVWebNodeUI'
import { CarouselCollectionItem } from './carouselCollectionItem'
import * as st from './carouselCollectionItem.module.scss'

const CarouselCollectionValid = tryCatch((props: ICollection) => {
  const {header, cardTitleIds, refTagPrefix} = props
  return (
    <div className={`dv-hover-packshot-container ${st.avSimsCarousel}`}>
      {header && (
        <h1 className={Spacing.base}>
          {header}
        </h1>
      )}
      <Carousel className={st.carouselWrapper}>
        {cardTitleIds.map((titleId, idx) => (
          <React.Fragment key={idx}>
            <CarouselCollectionItem idx={idx} titleId={titleId} refTagPrefix={refTagPrefix} />
          </React.Fragment>
        ))}
      </Carousel>
    </div>
  )
})

export const CarouselCollection = withFatalCheck(CarouselCollectionValid)
